var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',_vm._g(_vm._b({attrs:{"mode":"out-in","name":"page-change"}},'transition',_vm.$attrs,false),_vm.hooks),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }